"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStyles = function (props) {
    var className = props.className;
    return ({
        actions: [
            'ms-Dialog-actions',
            {
                position: 'relative',
                width: '100%',
                minHeight: '24px',
                lineHeight: '24px',
                margin: '20px 0 0',
                fontSize: '0',
                selectors: {
                    '.ms-Button': {
                        lineHeight: 'normal',
                    }
                }
            },
            className
        ],
        action: [
            'ms-Dialog-action',
        ],
        actionsRight: [
            'ms-Dialog-actionsRight',
            {
                textAlign: 'right',
                marginRight: '-4px',
                fontSize: '0',
                selectors: {
                    '$action': {
                        margin: '0 4px',
                    }
                }
            }
        ]
    });
};
//# sourceMappingURL=DialogFooter.styles.js.map